import React from 'react';
import { Grid } from '@material-ui/core';
import { JobModel } from '../NewsfeedModels';
import { Colors, Text } from 'library';
import JobCardChips from './JobCardChips';
import JobCardDetails from './JobCardDetails';
import JobCardAvatar from './JobCardAvatar';
import JobCardActions from './JobCardActions';
import { JobTypeIds } from '../../../../models/JobType';

interface IJobCard {
    job: JobModel;
}

const JobCard = ({ job }: IJobCard) => {
    const chips = [
        {
            text: 'PET CARE',
            flag: job.job_type_id === JobTypeIds.PetCare,
            color: Colors.mediumTurq,
            textColor: Colors.darkNavy,
            tooltipHeader: 'Pet care job',
            tooltipText: 'This job is for a pet.',
        },
        {
            text: 'QUICK FILL',
            flag: job.quick_fill,
            color: Colors.mediumGreen,
            textColor: Colors.darkNavy,
            tooltipHeader: 'No need to wait.',
            tooltipText:
                "Accepting this job means you're automatically confirmed as the provider! Make sure to message the family and show up on time on the day of the job.",
        },
        {
            text: 'WEEKLY',
            flag: job.ongoing,
            color: Colors.turquoise,
            textColor: Colors.white,
            tooltipHeader: 'Weekly job',
            tooltipText:
                "This job occurs every week on the days specified. Apply to this job and message the family to set up an interview. You'll get a notification if you're hired.",
        },
        {
            text: 'ONE-TIME',
            flag: !job.ongoing,
            color: Colors.turquoise,
            textColor: Colors.white,
            tooltipHeader: 'One-time job',
            tooltipText:
                'This job occurs one time. If it is also Quick Fill, all you have to do is accept. Otherwise, apply to the job and message the family to introduce yourself.',
        },
    ];
    return (
        <Grid container item xs={12} style={styles.card}>
            {job.job_headline ? (
                <Grid style={{ marginBottom: 16 }} container direction="row">
                    <Text variant="body1" textStyle={{ fontWeight: 900 }}>
                        {job.job_headline}
                    </Text>
                </Grid>
            ) : null}
            <Grid container direction="row">
                <Grid item xs={4}>
                    <JobCardAvatar job={job} />
                </Grid>
                <Grid item xs={8}>
                    <JobCardChips chips={chips} />
                    <JobCardDetails job={job} />
                </Grid>
            </Grid>
            <JobCardActions job={job} />
        </Grid>
    );
};

export default JobCard;

const styles = {
    card: {
        maxWidth: 450,
        backgroundColor: Colors.white,
        padding: 20,
        borderRadius: 18,
        justifyContent: 'space-between',
        boxShadow: '0px 3px 3px rgba(0,1,1,0.15)',
        border: '0.25px solid rgba(0,1,1,0.15)',
    },
};
